import {injectable} from "tsyringe";
import {DeleteKnowledgeObjectCommand} from "../commands/delete-knowledge-object.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {KnowledgeObject} from "../domain/entities/knowledge-object.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({source: DeleteKnowledgeObjectCommand, target: `dto`})
export class DeleteKnowledgeObjectCommandToDtoTransformer extends AbstractCommandToDtoTransformer<KnowledgeObject> {

    protected async toDTO(knowledgeObject: KnowledgeObject): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{uid: knowledgeObject.uid});
    }

}
